import { vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1a4e49b9"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "conWrap"
};
const _hoisted_2 = {
  class: "contitle"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "名称", -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "地图名称", -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "头部标题", -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "icon icon-prompt"
}, null, -1));
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "背景", -1));
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "logo", -1));
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "图例", -1));
const _hoisted_10 = {
  class: "p16"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "地图图片", -1));
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "层级", -1));
const _hoisted_13 = {
  class: "el-form-w2"
};
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "最小", -1));
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "最大", -1));
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "初始层级", -1));
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "位置", -1));
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "旋转与缩放", -1));
const _hoisted_19 = {
  class: "p16"
};
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "选择样式", -1));
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("ul", {
  class: "ullist"
}, [/*#__PURE__*/_createElementVNode("li", {
  class: "active"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "imgbox"
}, [/*#__PURE__*/_createElementVNode("i", {
  class: "icon-right"
}), /*#__PURE__*/_createElementVNode("img", {
  src: "https://p.ananas.chaoxing.com/star3/origin/41366b02eab51995cd14932390febc98.jpg",
  alt: ""
})]), /*#__PURE__*/_createElementVNode("h5", null, "样式1")]), /*#__PURE__*/_createElementVNode("li", null, [/*#__PURE__*/_createElementVNode("div", {
  class: "imgbox"
}, [/*#__PURE__*/_createElementVNode("i", {
  class: "icon-right"
}), /*#__PURE__*/_createElementVNode("img", {
  src: "https://p.ananas.chaoxing.com/star3/origin/41366b02eab51995cd14932390febc98.jpg",
  alt: ""
})]), /*#__PURE__*/_createElementVNode("h5", null, "样式2")]), /*#__PURE__*/_createElementVNode("li", null, [/*#__PURE__*/_createElementVNode("div", {
  class: "imgbox"
}, [/*#__PURE__*/_createElementVNode("i", {
  class: "icon-right"
}), /*#__PURE__*/_createElementVNode("img", {
  src: "https://p.ananas.chaoxing.com/star3/origin/41366b02eab51995cd14932390febc98.jpg",
  alt: ""
})]), /*#__PURE__*/_createElementVNode("h5", null, "样式3")])], -1));
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "分类按钮", -1));
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "外观", -1));
const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title-label mb8"
}, "分类背景", -1));
const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "定位", -1));
const _hoisted_26 = {
  class: "typeWrap p1216"
};
const _hoisted_27 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("ul", {
  class: "typelist"
}, [/*#__PURE__*/_createElementVNode("li", null, [/*#__PURE__*/_createElementVNode("div", {
  class: "imgbox"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: "https://p.ananas.chaoxing.com/star3/origin/4c040d613e3979bd9de57b6dfef3f1ad.png",
  alt: ""
}), /*#__PURE__*/_createElementVNode("i", {
  class: "icon icon-edit"
})]), /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "旅游景点"), /*#__PURE__*/_createElementVNode("div", {
  class: "titlebox"
}, [/*#__PURE__*/_createElementVNode("i", {
  class: "icon icon-edit"
}), /*#__PURE__*/_createElementVNode("i", {
  class: "icon icon-delete"
}), /*#__PURE__*/_createElementVNode("i", {
  class: "icon icon-more2"
})])]), /*#__PURE__*/_createElementVNode("li", null, [/*#__PURE__*/_createElementVNode("div", {
  class: "imgbox"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: "https://p.ananas.chaoxing.com/star3/origin/4c040d613e3979bd9de57b6dfef3f1ad.png",
  alt: ""
}), /*#__PURE__*/_createElementVNode("i", {
  class: "icon icon-edit"
})]), /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "文化场馆"), /*#__PURE__*/_createElementVNode("div", {
  class: "titlebox"
}, [/*#__PURE__*/_createElementVNode("i", {
  class: "icon icon-edit"
}), /*#__PURE__*/_createElementVNode("i", {
  class: "icon icon-delete"
}), /*#__PURE__*/_createElementVNode("i", {
  class: "icon icon-more2"
})])]), /*#__PURE__*/_createElementVNode("li", null, [/*#__PURE__*/_createElementVNode("div", {
  class: "imgbox"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: "https://p.ananas.chaoxing.com/star3/origin/4c040d613e3979bd9de57b6dfef3f1ad.png",
  alt: ""
}), /*#__PURE__*/_createElementVNode("i", {
  class: "icon icon-edit"
})]), /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "非遗"), /*#__PURE__*/_createElementVNode("div", {
  class: "titlebox"
}, [/*#__PURE__*/_createElementVNode("i", {
  class: "icon icon-edit"
}), /*#__PURE__*/_createElementVNode("i", {
  class: "icon icon-delete"
}), /*#__PURE__*/_createElementVNode("i", {
  class: "icon icon-more2"
})])])], -1));
const _hoisted_28 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title-label p1216"
}, "全局设置", -1));
const _hoisted_29 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "点位名称", -1));
const _hoisted_30 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "conline"
}, null, -1));
const _hoisted_31 = {
  class: "textlimit"
};
const _hoisted_32 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title-label"
}, "字数限制", -1));
const _hoisted_33 = {
  class: "form-item"
};
const _hoisted_34 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "行数", -1));
const _hoisted_35 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "每行字数", -1));
const _hoisted_36 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "点位图片", -1));
const _hoisted_37 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "conline"
}, null, -1));
const _hoisted_38 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title-label mb8"
}, "图片尺寸", -1));
const _hoisted_39 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title-label mb8"
}, "名称与图片间距", -1));
const _hoisted_40 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "点位图标", -1));
const _hoisted_41 = {
  class: "pointWrap p1216"
};
const _hoisted_42 = {
  class: "searchwrap"
};
const _hoisted_43 = {
  class: "pointcell"
};
const _hoisted_44 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "共203条", -1));
const _hoisted_45 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("ul", {
  class: "pointlist"
}, [/*#__PURE__*/_createElementVNode("li", null, [/*#__PURE__*/_createElementVNode("div", {
  class: "imgbox"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: "https://p.ananas.chaoxing.com/star3/origin/4dd7f70a04ce0508fc5dd51b89782153.png",
  alt: ""
})]), /*#__PURE__*/_createElementVNode("div", {
  class: "txtbox"
}, [/*#__PURE__*/_createElementVNode("h4", {
  class: "title"
}, "旅游景点"), /*#__PURE__*/_createElementVNode("p", null, "文化")]), /*#__PURE__*/_createElementVNode("i", {
  class: "icon icon-delete"
})]), /*#__PURE__*/_createElementVNode("li", null, [/*#__PURE__*/_createElementVNode("div", {
  class: "imgbox"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: "https://p.ananas.chaoxing.com/star3/origin/4dd7f70a04ce0508fc5dd51b89782153.png",
  alt: ""
})]), /*#__PURE__*/_createElementVNode("div", {
  class: "txtbox"
}, [/*#__PURE__*/_createElementVNode("h4", {
  class: "title"
}, "旅游景点"), /*#__PURE__*/_createElementVNode("p", null, "文化")]), /*#__PURE__*/_createElementVNode("i", {
  class: "icon icon-delete"
})])], -1));
const _hoisted_46 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "选择样式", -1));
const _hoisted_47 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("ul", {
  class: "ullist big"
}, [/*#__PURE__*/_createElementVNode("li", {
  class: "active"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "imgbox"
}, [/*#__PURE__*/_createElementVNode("i", {
  class: "icon-right"
}), /*#__PURE__*/_createElementVNode("img", {
  src: "https://p.ananas.chaoxing.com/star3/origin/b92b46ad872e9c96563eb4815c89d3ab.jpg",
  alt: ""
})]), /*#__PURE__*/_createElementVNode("h5", null, "样式1")]), /*#__PURE__*/_createElementVNode("li", null, [/*#__PURE__*/_createElementVNode("div", {
  class: "imgbox"
}, [/*#__PURE__*/_createElementVNode("i", {
  class: "icon-right"
}), /*#__PURE__*/_createElementVNode("img", {
  src: "https://p.ananas.chaoxing.com/star3/origin/b92b46ad872e9c96563eb4815c89d3ab.jpg",
  alt: ""
})]), /*#__PURE__*/_createElementVNode("h5", null, "样式2")]), /*#__PURE__*/_createElementVNode("li", null, [/*#__PURE__*/_createElementVNode("div", {
  class: "imgbox"
}, [/*#__PURE__*/_createElementVNode("i", {
  class: "icon-right"
}), /*#__PURE__*/_createElementVNode("img", {
  src: "https://p.ananas.chaoxing.com/star3/origin/b92b46ad872e9c96563eb4815c89d3ab.jpg",
  alt: ""
})]), /*#__PURE__*/_createElementVNode("h5", null, "样式3")])], -1));
const _hoisted_48 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "外观", -1));
const _hoisted_49 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "访问量", -1));
const _hoisted_50 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "真实访问量", -1));
const _hoisted_51 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "自定义访问增量", -1));
const _hoisted_52 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "智能客服", -1));
const _hoisted_53 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "底部信息", -1));
const _hoisted_54 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "进入特效", -1));
const _hoisted_55 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "其他", -1));
const _hoisted_56 = {
  class: "textlimit"
};
const _hoisted_57 = {
  class: "form-item"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CaretBottom = _resolveComponent("CaretBottom");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_collapse_item = _resolveComponent("el-collapse-item");
  const _component_upload_image = _resolveComponent("upload-image");
  const _component_slider_input = _resolveComponent("slider-input");
  const _component_map_position = _resolveComponent("map-position");
  const _component_el_radio = _resolveComponent("el-radio");
  const _component_el_radio_group = _resolveComponent("el-radio-group");
  const _component_el_checkbox = _resolveComponent("el-checkbox");
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group");
  const _component_el_tab_pane = _resolveComponent("el-tab-pane");
  const _component_el_tabs = _resolveComponent("el-tabs");
  const _component_font_style = _resolveComponent("font-style");
  const _component_gpickr = _resolveComponent("gpickr");
  const _component_Plus = _resolveComponent("Plus");
  const _component_el_button = _resolveComponent("el-button");
  const _component_linkwh = _resolveComponent("linkwh");
  const _component_Search = _resolveComponent("Search");
  const _component_el_collapse = _resolveComponent("el-collapse");
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["configWrap", {
      'hide': !$data.leftconflag
    }])
  }, [_withDirectives(_createElementVNode("div", {
    class: "launch icon-shrink",
    onClick: _cache[0] || (_cache[0] = $event => $data.leftconflag = true)
  }, null, 512), [[_vShow, !$data.leftconflag]]), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("span", null, _toDisplayString($data.titleInfo[$props.id].name), 1), _createElementVNode("i", {
    class: "icon-shrink",
    onClick: _cache[1] || (_cache[1] = $event => $data.leftconflag = false)
  })]), _createVNode(_component_el_collapse, {
    modelValue: $data.activeNames,
    "onUpdate:modelValue": _cache[28] || (_cache[28] = $event => $data.activeNames = $event),
    onChange: $options.handleChange
  }, {
    default: _withCtx(() => [_withDirectives(_createElementVNode("div", null, [_createVNode(_component_el_collapse_item, {
      name: "1"
    }, {
      title: _withCtx(() => [_createVNode(_component_el_icon, {
        class: "icon"
      }, {
        default: _withCtx(() => [_createVNode(_component_CaretBottom)]),
        _: 1
      }), _hoisted_3]),
      default: _withCtx(() => [_createVNode(_component_el_form_item, null, {
        label: _withCtx(() => [_hoisted_4]),
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.name,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.name = $event)
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, null, {
        label: _withCtx(() => [_hoisted_5, _hoisted_6]),
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.name,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.name = $event)
        }, null, 8, ["modelValue"])]),
        _: 1
      })]),
      _: 1
    }), _createVNode(_component_el_collapse_item, {
      name: "2"
    }, {
      title: _withCtx(() => [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_component_CaretBottom)]),
        _: 1
      }), _hoisted_7]),
      default: _withCtx(() => [_createVNode(_component_upload_image, {
        width: 90,
        height: 90
      })]),
      _: 1
    }), _createVNode(_component_el_collapse_item, {
      name: "3"
    }, {
      title: _withCtx(() => [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_component_CaretBottom)]),
        _: 1
      }), _hoisted_8]),
      default: _withCtx(() => [_createVNode(_component_upload_image, {
        class: "mb16"
      }), _createVNode(_component_slider_input, {
        title: "宽度",
        size: 16
      }), _createVNode(_component_map_position)]),
      _: 1
    }), _createVNode(_component_el_collapse_item, {
      name: "3"
    }, {
      title: _withCtx(() => [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_component_CaretBottom)]),
        _: 1
      }), _hoisted_9]),
      default: _withCtx(() => [_createVNode(_component_upload_image, {
        class: "mb16"
      }), _createVNode(_component_slider_input, {
        title: "宽度",
        size: 16
      }), _createVNode(_component_map_position)]),
      _: 1
    })], 512), [[_vShow, $props.id === 0]]), _withDirectives(_createElementVNode("div", null, [_createElementVNode("div", _hoisted_10, [_createVNode(_component_el_radio_group, {
      modelValue: $data.radio1,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $data.radio1 = $event)
    }, {
      default: _withCtx(() => [_createVNode(_component_el_radio, {
        label: 1
      }, {
        default: _withCtx(() => [_createTextVNode("静态地图")]),
        _: 1
      }), _createVNode(_component_el_radio, {
        label: 2
      }, {
        default: _withCtx(() => [_createTextVNode("切片地图")]),
        _: 1
      })]),
      _: 1
    }, 8, ["modelValue"])]), _createVNode(_component_el_collapse_item, {
      name: "5"
    }, {
      title: _withCtx(() => [_createVNode(_component_el_icon, {
        class: "icon"
      }, {
        default: _withCtx(() => [_createVNode(_component_CaretBottom)]),
        _: 1
      }), _hoisted_11]),
      default: _withCtx(() => [_createVNode(_component_upload_image, {
        width: 90,
        height: 90
      })]),
      _: 1
    }), _createVNode(_component_el_collapse_item, {
      name: "6"
    }, {
      title: _withCtx(() => [_createVNode(_component_el_icon, {
        class: "icon"
      }, {
        default: _withCtx(() => [_createVNode(_component_CaretBottom)]),
        _: 1
      }), _hoisted_12]),
      default: _withCtx(() => [_createElementVNode("div", _hoisted_13, [_createVNode(_component_el_form_item, null, {
        label: _withCtx(() => [_hoisted_14]),
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.name,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $data.name = $event)
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, null, {
        label: _withCtx(() => [_hoisted_15]),
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.name,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => $data.name = $event)
        }, null, 8, ["modelValue"])]),
        _: 1
      })]), _createVNode(_component_el_form_item, null, {
        label: _withCtx(() => [_hoisted_16]),
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.name,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => $data.name = $event)
        }, null, 8, ["modelValue"])]),
        _: 1
      })]),
      _: 1
    }), _createVNode(_component_el_collapse_item, {
      name: "7"
    }, {
      title: _withCtx(() => [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_component_CaretBottom)]),
        _: 1
      }), _hoisted_17]),
      default: _withCtx(() => [_createVNode(_component_upload_image, {
        class: "mb16"
      }), _createVNode(_component_slider_input, {
        title: "X轴",
        size: 16
      }), _createVNode(_component_slider_input, {
        title: "Y轴",
        size: 16
      })]),
      _: 1
    }), _createVNode(_component_el_collapse_item, {
      name: "8"
    }, {
      title: _withCtx(() => [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_component_CaretBottom)]),
        _: 1
      }), _hoisted_18]),
      default: _withCtx(() => [_createVNode(_component_el_checkbox_group, {
        modelValue: $data.checkList,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => $data.checkList = $event)
      }, {
        default: _withCtx(() => [_createVNode(_component_el_checkbox, {
          label: "禁止缩放",
          value: "0"
        }), _createVNode(_component_el_checkbox, {
          label: "禁止旋转",
          value: "1"
        })]),
        _: 1
      }, 8, ["modelValue"])]),
      _: 1
    })], 512), [[_vShow, $props.id === 1]]), _withDirectives(_createElementVNode("div", null, [_createVNode(_component_el_tabs, {
      modelValue: $data.switchtab1,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => $data.switchtab1 = $event),
      class: "switchTab1",
      onTabClick: _ctx.handleClick
    }, {
      default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
        label: "样式",
        name: "first"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_19, [_createVNode(_component_el_radio_group, {
          modelValue: $data.typename,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => $data.typename = $event)
        }, {
          default: _withCtx(() => [_createVNode(_component_el_radio, {
            label: 1
          }, {
            default: _withCtx(() => [_createTextVNode("显示分类")]),
            _: 1
          }), _createVNode(_component_el_radio, {
            label: 2
          }, {
            default: _withCtx(() => [_createTextVNode("隐藏分类")]),
            _: 1
          })]),
          _: 1
        }, 8, ["modelValue"])]), _createVNode(_component_el_collapse_item, {
          name: "9"
        }, {
          title: _withCtx(() => [_createVNode(_component_el_icon, null, {
            default: _withCtx(() => [_createVNode(_component_CaretBottom)]),
            _: 1
          }), _hoisted_20]),
          default: _withCtx(() => [_hoisted_21]),
          _: 1
        }), _createVNode(_component_el_collapse_item, {
          name: "10"
        }, {
          title: _withCtx(() => [_createVNode(_component_el_icon, null, {
            default: _withCtx(() => [_createVNode(_component_CaretBottom)]),
            _: 1
          }), _hoisted_22]),
          default: _withCtx(() => [_createVNode(_component_el_tabs, {
            modelValue: $data.switchtab2,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => $data.switchtab2 = $event),
            class: "switchTab1 small",
            onTabClick: _ctx.handleClick
          }, {
            default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
              label: "默认",
              name: "first"
            }), _createVNode(_component_el_tab_pane, {
              label: "选中",
              name: "second"
            })]),
            _: 1
          }, 8, ["modelValue", "onTabClick"]), _createVNode(_component_font_style), _createVNode(_component_slider_input, {
            title: "按钮宽度",
            size: 16
          }), _createVNode(_component_slider_input, {
            title: "按钮高度",
            size: 16
          }), _createVNode(_component_slider_input, {
            title: "按钮间距",
            size: 16
          }), _createVNode(_component_upload_image, {
            class: "mb16"
          })]),
          _: 1
        }), _createVNode(_component_el_collapse_item, {
          name: "11"
        }, {
          title: _withCtx(() => [_createVNode(_component_el_icon, null, {
            default: _withCtx(() => [_createVNode(_component_CaretBottom)]),
            _: 1
          }), _hoisted_23]),
          default: _withCtx(() => [_createVNode(_component_slider_input, {
            title: "分类宽度",
            size: 200
          }), _hoisted_24, _createVNode(_component_gpickr)]),
          _: 1
        }), _createVNode(_component_el_collapse_item, {
          name: "12"
        }, {
          title: _withCtx(() => [_createVNode(_component_el_icon, null, {
            default: _withCtx(() => [_createVNode(_component_CaretBottom)]),
            _: 1
          }), _hoisted_25]),
          default: _withCtx(() => [_createVNode(_component_map_position)]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_tab_pane, {
        label: "数据",
        name: "second"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_26, [_createVNode(_component_el_button, {
          class: "w100",
          plain: ""
        }, {
          default: _withCtx(() => [_createVNode(_component_el_icon, null, {
            default: _withCtx(() => [_createVNode(_component_Plus)]),
            _: 1
          }), _createTextVNode("添加分类")]),
          _: 1
        }), _hoisted_27])]),
        _: 1
      })]),
      _: 1
    }, 8, ["modelValue", "onTabClick"])], 512), [[_vShow, $props.id === 2]]), _withDirectives(_createElementVNode("div", null, [_createVNode(_component_el_tabs, {
      modelValue: $data.switchtab3,
      "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => $data.switchtab3 = $event),
      class: "switchTab1",
      onTabClick: _ctx.handleClick
    }, {
      default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
        label: "样式",
        name: "first"
      }, {
        default: _withCtx(() => [_hoisted_28, _createVNode(_component_el_collapse_item, {
          name: "13"
        }, {
          title: _withCtx(() => [_createVNode(_component_el_icon, null, {
            default: _withCtx(() => [_createVNode(_component_CaretBottom)]),
            _: 1
          }), _hoisted_29]),
          default: _withCtx(() => [_createVNode(_component_el_radio_group, {
            modelValue: $data.radio3,
            "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => $data.radio3 = $event)
          }, {
            default: _withCtx(() => [_createVNode(_component_el_radio, {
              label: 1
            }, {
              default: _withCtx(() => [_createTextVNode("显示")]),
              _: 1
            }), _createVNode(_component_el_radio, {
              label: 2
            }, {
              default: _withCtx(() => [_createTextVNode("隐藏")]),
              _: 1
            }), _createVNode(_component_el_radio, {
              label: 3
            }, {
              default: _withCtx(() => [_createTextVNode("鼠标移入显示")]),
              _: 1
            })]),
            _: 1
          }, 8, ["modelValue"]), _hoisted_30, _createVNode(_component_font_style), _createVNode(_component_gpickr, {
            title: "文字背景"
          }), _createVNode(_component_gpickr, {
            title: "文字描边"
          }), _createElementVNode("div", _hoisted_31, [_hoisted_32, _createElementVNode("div", _hoisted_33, [_createVNode(_component_el_form_item, null, {
            label: _withCtx(() => [_hoisted_34]),
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: $data.name,
              "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => $data.name = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, null, {
            label: _withCtx(() => [_hoisted_35]),
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: $data.name,
              "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => $data.name = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          })])])]),
          _: 1
        }), _createVNode(_component_el_collapse_item, {
          name: "14"
        }, {
          title: _withCtx(() => [_createVNode(_component_el_icon, null, {
            default: _withCtx(() => [_createVNode(_component_CaretBottom)]),
            _: 1
          }), _hoisted_36]),
          default: _withCtx(() => [_createVNode(_component_el_radio_group, {
            modelValue: $data.radio4,
            "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => $data.radio4 = $event)
          }, {
            default: _withCtx(() => [_createVNode(_component_el_radio, {
              label: 1
            }, {
              default: _withCtx(() => [_createTextVNode("显示")]),
              _: 1
            }), _createVNode(_component_el_radio, {
              label: 2
            }, {
              default: _withCtx(() => [_createTextVNode("隐藏")]),
              _: 1
            }), _createVNode(_component_el_radio, {
              label: 3
            }, {
              default: _withCtx(() => [_createTextVNode("鼠标移入显示")]),
              _: 1
            })]),
            _: 1
          }, 8, ["modelValue"]), _hoisted_37, _createElementVNode("div", null, [_hoisted_38, _createVNode(_component_linkwh)]), _createElementVNode("div", null, [_hoisted_39, _createVNode(_component_slider_input, {
            title: "",
            size: 1
          })])]),
          _: 1
        }), _createVNode(_component_el_collapse_item, {
          name: "15"
        }, {
          title: _withCtx(() => [_createVNode(_component_el_icon, null, {
            default: _withCtx(() => [_createVNode(_component_CaretBottom)]),
            _: 1
          }), _hoisted_40]),
          default: _withCtx(() => [_createVNode(_component_el_radio_group, {
            modelValue: $data.radio5,
            "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => $data.radio5 = $event)
          }, {
            default: _withCtx(() => [_createVNode(_component_el_radio, {
              label: 1
            }, {
              default: _withCtx(() => [_createTextVNode("显示")]),
              _: 1
            }), _createVNode(_component_el_radio, {
              label: 2
            }, {
              default: _withCtx(() => [_createTextVNode("隐藏")]),
              _: 1
            })]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_tab_pane, {
        label: "数据",
        name: "second"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_41, [_createElementVNode("div", _hoisted_42, [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_component_Search)]),
          _: 1
        }), _createVNode(_component_el_input, {
          modelValue: _ctx.input,
          "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => _ctx.input = $event),
          placeholder: "搜索"
        }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_43, [_createVNode(_component_el_button, {
          plain: ""
        }, {
          default: _withCtx(() => [_createVNode(_component_el_icon, null, {
            default: _withCtx(() => [_createVNode(_component_Plus)]),
            _: 1
          }), _createTextVNode("添加点位")]),
          _: 1
        }), _hoisted_44]), _hoisted_45])]),
        _: 1
      })]),
      _: 1
    }, 8, ["modelValue", "onTabClick"])], 512), [[_vShow, $props.id === 3]]), _withDirectives(_createElementVNode("div", null, [_createVNode(_component_el_collapse_item, {
      name: "16"
    }, {
      title: _withCtx(() => [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_component_CaretBottom)]),
        _: 1
      }), _hoisted_46]),
      default: _withCtx(() => [_hoisted_47]),
      _: 1
    }), _createVNode(_component_el_collapse_item, {
      name: "17"
    }, {
      title: _withCtx(() => [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_component_CaretBottom)]),
        _: 1
      }), _hoisted_48]),
      default: _withCtx(() => [_createVNode(_component_gpickr, {
        title: "弹窗主题色"
      })]),
      _: 1
    })], 512), [[_vShow, $props.id === 4]]), _withDirectives(_createElementVNode("div", null, [_createVNode(_component_el_collapse_item, {
      name: "18"
    }, {
      title: _withCtx(() => [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_component_CaretBottom)]),
        _: 1
      }), _hoisted_49]),
      default: _withCtx(() => [_createVNode(_component_el_checkbox, {
        class: "mb12",
        modelValue: $data.checked1,
        "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => $data.checked1 = $event),
        label: "开启访问量"
      }, null, 8, ["modelValue"]), _createVNode(_component_el_form_item, null, {
        label: _withCtx(() => [_hoisted_50]),
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.name,
          "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => $data.name = $event)
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, null, {
        label: _withCtx(() => [_hoisted_51]),
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.name,
          "onUpdate:modelValue": _cache[21] || (_cache[21] = $event => $data.name = $event)
        }, null, 8, ["modelValue"])]),
        _: 1
      })]),
      _: 1
    }), _createVNode(_component_el_collapse_item, {
      name: "19"
    }, {
      title: _withCtx(() => [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_component_CaretBottom)]),
        _: 1
      }), _hoisted_52]),
      default: _withCtx(() => [_createVNode(_component_el_checkbox, {
        class: "mb16",
        modelValue: $data.checked1,
        "onUpdate:modelValue": _cache[22] || (_cache[22] = $event => $data.checked1 = $event),
        label: "开启智能客服"
      }, null, 8, ["modelValue"]), _createVNode(_component_el_input, {
        modelValue: $data.textarea2,
        "onUpdate:modelValue": _cache[23] || (_cache[23] = $event => $data.textarea2 = $event),
        style: {
          "width": "240px"
        },
        autosize: {
          minRows: 2,
          maxRows: 4
        },
        type: "textarea",
        placeholder: "接入智能客服代码"
      }, null, 8, ["modelValue"])]),
      _: 1
    }), _createVNode(_component_el_collapse_item, {
      name: "19"
    }, {
      title: _withCtx(() => [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_component_CaretBottom)]),
        _: 1
      }), _hoisted_53]),
      default: _withCtx(() => [_createVNode(_component_el_input, {
        modelValue: $data.textarea2,
        "onUpdate:modelValue": _cache[24] || (_cache[24] = $event => $data.textarea2 = $event),
        style: {
          "width": "240px"
        },
        autosize: {
          minRows: 2,
          maxRows: 4
        },
        type: "textarea",
        placeholder: ""
      }, null, 8, ["modelValue"])]),
      _: 1
    }), _createVNode(_component_el_collapse_item, {
      name: "20"
    }, {
      title: _withCtx(() => [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_component_CaretBottom)]),
        _: 1
      }), _hoisted_54]),
      default: _withCtx(() => [_createVNode(_component_el_checkbox, {
        modelValue: $data.checked1,
        "onUpdate:modelValue": _cache[25] || (_cache[25] = $event => $data.checked1 = $event),
        label: "开启特效"
      }, null, 8, ["modelValue"])]),
      _: 1
    }), _createVNode(_component_el_collapse_item, {
      name: "21"
    }, {
      title: _withCtx(() => [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_component_CaretBottom)]),
        _: 1
      }), _hoisted_55]),
      default: _withCtx(() => [_createVNode(_component_el_checkbox, {
        class: "mb12",
        modelValue: $data.checked1,
        "onUpdate:modelValue": _cache[26] || (_cache[26] = $event => $data.checked1 = $event),
        label: "开启画线"
      }, null, 8, ["modelValue"]), _createElementVNode("div", _hoisted_56, [_createVNode(_component_el_checkbox, {
        modelValue: $data.checked1,
        "onUpdate:modelValue": _cache[27] || (_cache[27] = $event => $data.checked1 = $event),
        label: "开启复位功能"
      }, null, 8, ["modelValue"]), _createElementVNode("div", _hoisted_57, [_createVNode(_component_upload_image)])])]),
      _: 1
    })], 512), [[_vShow, $props.id === 5]])]),
    _: 1
  }, 8, ["modelValue", "onChange"])])], 2);
}